<template>
  <img :src="qrCodeData" alt="QR Code" class="plc-qr" />
</template>

<script>
import qrCode from 'qrcode'

export default {
  name: 'AddressDetailsQr',
  props: {
    data: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      qrCodeData: null,
    }
  },
  created() {
    qrCode.toDataURL(
      this.data,
      { margin: 2, width: 224, errorCorrectionLevel: 'H' },
      (err, data) => {
        if (!err) {
          this.qrCodeData = data
        }
      }
    )
  },
}
</script>

<style lang="scss" scoped>
.plc-qr {
  width: 100%;
}
</style>
